import apiClient from './client'

export const reviewsApi = {
  getCourseReviews: async (courseId, params = {}) => {
    const response = await apiClient.get(`/courses/${courseId}/reviews`, { params })
    return response.data
  },

  getMyReview: async (courseId) => {
    const response = await apiClient.get(`/courses/${courseId}/reviews/mine`)
    return response.data
  },

  // Reviewing again replaces the student's existing review rather than adding
  // a second one, and sends it back for approval.
  submitReview: async (courseId, data) => {
    const response = await apiClient.post(`/courses/${courseId}/reviews`, data)
    return response.data
  },
}
